export default __webpack_public_path__ + "static/media/JunnieAt3.e9f41b81.gif";